import {combineReducers} from '@reduxjs/toolkit';

import {accountAuditLogStateSlice} from './slices/account-audit-log-state.slice';
import {accountAuditLogSlice} from './slices/account-audit-log.slice';

export const accountAuditReducer = combineReducers({
    events: accountAuditLogSlice.reducer,
    state: accountAuditLogStateSlice.reducer,
});
